import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import FloatingContactActions from './floating-contact-actions';

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
      <FloatingContactActions />
    </div>
  );
};

export default Layout;
